import { APP_NAME } from "@constants/app.constants";
import AdminModuleComponent from "@screens/admin-module/admin-module.component";
import AttendanceComponent from "@screens/admin-module/attendance/attendance.component";

const adminModuleRoutes = [
  {
    name: "Admin Module - " + APP_NAME,
    icon: "slash",
    path: "/admin-module",
    component: AdminModuleComponent,
  },
  {
    name: "Attendance - " + APP_NAME,
    icon: "slash",
    path: "/admin-module/attendance/test",
    component: AttendanceComponent,
  },
];

export default adminModuleRoutes;
